"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var verifyApiVersion = require("./api-verify.js");
var _require$DocUtils = require("docxtemplater").DocUtils,
  traits = _require$DocUtils.traits,
  chunkBy = _require$DocUtils.chunkBy;
var _require = require("docxtemplater/js/lexer.js"),
  xmlparse = _require.xmlparse;
var xml2str = require("docxtemplater").DocUtils.xml2str;
var getType = require("./get-type.js");
var HtmlTransformer = require("./html-transformer.js");
var _require2 = require("./html-utils.js"),
  getHtmlContent = _require2.getHtmlContent;
var _require3 = require("./converter.js"),
  dxaToPixel = _require3.dxaToPixel;
var _require4 = require("./tag.js"),
  isStartingTag = _require4.isStartingTag;
var _require5 = require("./html-utils.js"),
  tapRecursive = _require5.tapRecursive,
  getTextContent = _require5.getTextContent;
var _require6 = require("lodash"),
  merge = _require6.merge,
  pick = _require6.pick;
var StyleManager = require("./style-manager.js");
var moduleNameBlock = "pro-xml-templating/html-module-block";
var moduleNameInline = "pro-xml-templating/html-module-inline";
var ListHandler = require("./list-handler.js");
var docStyles = require("./doc-styles.js");
var _require7 = require("./tags.js"),
  TagRepository = _require7.TagRepository;
var Docxtemplater = require("docxtemplater");
var _require8 = require("./attributes.js"),
  getSingleAttribute = _require8.getSingleAttribute;
var _require9 = require("./style.js"),
  forEachStyleDeclaration = _require9.forEachStyleDeclaration;
var _require10 = require("./regex.js"),
  percentRegex = _require10.percentRegex;
var cssParse = require("./css-parse.js");
var _require11 = require("./content-types.js"),
  main = _require11.main;
var dimensionCollector = require("./get-dimensions.js");
var addCustomProperties = require("./add-custom-properties.js");
var pushArray = require("./push-array.js");
var getRelsFilePath = require("./rels-file-path.js");
function copyDimensionsToPart(dimensions, part) {
  var containerWidth = dimensions.containerWidth,
    containerHeight = dimensions.containerHeight,
    pageHeight = dimensions.pageHeight,
    pageWidth = dimensions.pageWidth,
    section = dimensions.section;
  part.containerWidth = containerWidth;
  part.containerHeight = containerHeight;
  if (pageHeight) {
    part.pageHeight = pageHeight;
  }
  if (pageWidth) {
    part.pageWidth = pageWidth;
  }
  part.section = section;
}
function base64DataURLToArrayBuffer(dataURL) {
  var stringBase64 = dataURL.replace(/^data:image\/([a-z]+);base64,/, "");
  var binaryString;
  if (typeof window !== "undefined") {
    binaryString = window.atob(stringBase64);
  } else {
    binaryString = Buffer.from(stringBase64, "base64").toString("binary");
  }
  var len = binaryString.length;
  var bytes = new Uint8Array(len);
  for (var i = 0; i < len; i++) {
    var ascii = binaryString.charCodeAt(i);
    bytes[i] = ascii;
  }
  return bytes.buffer;
}
function hasColumnBreak(chunk) {
  return chunk.some(function (part) {
    if (part.tag === "w:br" && part.value.indexOf('w:type="column"') !== -1) {
      return true;
    }
  });
}
function getInner(_ref) {
  var leftParts = _ref.leftParts,
    part = _ref.part;
  part.hasColumnBreak = hasColumnBreak(leftParts);
  return part;
}
function getProperties(parts, tagName) {
  var levelFilter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var inTag = false;
  var level = 0;
  var properties = [];
  for (var i = 0, len = parts.length; i < len; i++) {
    var part = parts[i];
    var type = part.type,
      tag = part.tag,
      position = part.position;
    if (inTag) {
      if (type === "tag" && tag === tagName && position === "end") {
        inTag = false;
        continue;
      }
      properties.push(part);
    }
    if (type === "tag") {
      if (position === "start") {
        if (tag === tagName && (levelFilter === null || levelFilter === level)) {
          inTag = true;
        }
        level++;
      }
      if (position === "end") {
        level--;
      }
    }
  }
  return properties;
}
var defaultSizeConverters = {
  paddingLeft: 15
};
var HtmlModule = /*#__PURE__*/function () {
  function HtmlModule() {
    var _options$warnFn;
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, HtmlModule);
    this.transformers = {};
    this.priority = -6;
    this.columnNum = 0;
    this.supportedFileTypes = ["docx"];
    this.warnFn = (_options$warnFn = options.warnFn) !== null && _options$warnFn !== void 0 ? _options$warnFn : function (errors) {
      var fullError = errors.map(function (error) {
        if (error.message) {
          return error.message;
        }
        return "";
      }).join(",");
      // eslint-disable-next-line no-console
      console.error("Warning parsing HTML content : ".concat(fullError));
    };
    this.requiredAPIVersion = "3.38.0";
    this.resolved = {};
    this.sections = [];
    this.W = {};
    this.prefix = "~";
    this.blockPrefix = "~~";
    this.dpi = options.dpi || 75;
    this.name = "HtmlModule";
    this.minBookmarkId = 1;
    this.htmlSections = [];
    this.styleSheetErrors = [];
    this.elementCustomizer = options.elementCustomizer || function () {
      return undefined;
    };
    this.tagRepository = new TagRepository({
      getTag: function getTag(tags, name) {
        if (!tags[name]) {
          if (options.ignoreUnknownTags) {
            return tags.span;
          }
          var err = new Docxtemplater.Errors.RenderingError("Tag ".concat(name, " not supported"));
          err.properties = {
            explanation: "The tag ".concat(name, " is not supported"),
            name: name,
            id: "html_tag_name_unsupported"
          };
          throw err;
        }
        return tags[name];
      }
    });
    this.sizeConverters = merge({}, defaultSizeConverters, options.sizeConverters);
    if (options.img) {
      var img = options.img;
      img.getValue || (img.getValue = function (element) {
        return base64DataURLToArrayBuffer(element.attribs.src || "");
      });
      var imModule = this.img = new options.img.Module({
        getImage: function getImage(image, options) {
          var hc = image.htmlContent;
          if (hc.indexOf("<svg ") !== -1) {
            return hc;
          }
          return img.getValue(image.element, image, options);
        },
        getProps: function getProps(buf, value) {
          var props = {};
          if (value.element.customProperties) {
            props.pStyle = value.element.customProperties.pStyle;
          }
          if (img.getProps) {
            var imgProps = img.getProps(_objectSpread(_objectSpread({}, value), {}, {
              src: buf
            }));
            if (imgProps.then) {
              return imgProps.then(function (imgProps) {
                return _objectSpread(_objectSpread({}, props), imgProps);
              });
            }
            props = _objectSpread(_objectSpread({}, props), imgProps);
          }
          return props;
        },
        getSize: function getSize(buf, value, __) {
          var vals = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
          var transformer = value.transformer;
          imModule.dpi = transformer.dpi;
          var srcSize = null;
          if (img.getSrcSize) {
            srcSize = img.getSrcSize(_objectSpread(_objectSpread({}, value), {}, {
              src: buf
            }), vals.part.value.htmlContent, value.part.value, vals.part);
          }
          if (img.getSize) {
            return img.getSize(_objectSpread(_objectSpread({}, value), {}, {
              src: buf
            }), vals.part.value.htmlContent, value.part.value, vals);
          }
          var percentWidth = null;
          forEachStyleDeclaration(value.element, value.transformer, function (_ref2) {
            var property = _ref2.property,
              value = _ref2.value;
            if (property === "width" && percentWidth == null && percentRegex.test(value)) {
              percentWidth = parseInt(value, 10);
            }
          });
          if (percentWidth && srcSize) {
            var imgWidth;
            if (value.element.parent.name === "td" && value.element.parent.calculatedWidth) {
              imgWidth = dxaToPixel(value.element.parent.calculatedWidth, transformer.dpi) * percentWidth / 100;
            } else {
              imgWidth = percentWidth / 100 * transformer.part.containerWidth;
            }
            var imgHeight = srcSize[1] / srcSize[0] * imgWidth;
            return [imgWidth, imgHeight];
          }
          if (vals.svgSize === null) {
            return [500, 500];
          }
          if (vals.svgSize) {
            return vals.svgSize;
          }
          if (value.element.attribs.width && value.element.attribs.height) {
            return [parseInt(value.element.attribs.width, 10), parseInt(value.element.attribs.height, 10)];
          }
          return [200, 200];
        }
      });
      imModule.W = this.W;
    }
    if (options.styleSheet) {
      var type = _typeof(options.styleSheet);
      if (type !== "string") {
        var err = new Docxtemplater.Errors.XTError("stylesheet must be a string, but received ".concat(type));
        err.properties = {
          explanation: "The HTML module styleSheet option must be a string",
          id: "html_module_stylesheet_not_string"
        };
        throw err;
      }
      var parsedResult = cssParse(options.styleSheet, _objectSpread(_objectSpread({}, options), {}, {
        source: "stylesheet-option"
      }));
      this.styleSheet = parsedResult.parsed;
      this.styleSheetErrors = parsedResult.errors;
      this.rawStyleSheet = options.styleSheet;
    }
    this.options = options;
  }
  _createClass(HtmlModule, [{
    key: "clone",
    value: function clone() {
      var module = new HtmlModule(this.options);
      module.prefix = this.prefix;
      module.blockPrefix = this.blockPrefix;
      return module;
    }
  }, {
    key: "set",
    value: function set(options) {
      if (this.img) {
        this.img.set(options);
      }
      if (options.xmlDocuments) {
        this.xmlDocuments = options.xmlDocuments;
        this.listHandler = new ListHandler(this);
      }
      if (options.inspect && options.inspect.filePath) {
        this.filePath = options.inspect.filePath;
      }
    }
  }, {
    key: "addStyles",
    value: function addStyles() {
      this.styleManager = new StyleManager(this.xmlDocuments);
      this.styleManager.addStyles();
      this.synonyms = this.styleManager.usedSynonyms;
      this.styleIds = this.styleManager.styleIds;
      this.styleDefaults = this.styleManager.getDefaultStyles();
      this.stylesXml = this.styleManager.stylesXml;
      if (this.options.styleTransformer) {
        this.tagRepository.tags = this.options.styleTransformer(this.tagRepository.tags, docStyles(), this);
      }
      this.tagRepository.styleDefaults = this.styleDefaults;
    }
  }, {
    key: "getNextWSect",
    value: function getNextWSect(lIndex) {
      if (this.htmlSections.length === 0) {
        // default section
        return {
          width: 11906,
          leftMargin: 1701,
          rightMargin: 850
        };
      }
      for (var i = 0, len = this.htmlSections.length; i < len; i++) {
        var section = this.htmlSections[i];
        if (section.lIndex > lIndex) {
          return section;
        }
      }
      throw new Error("Section not found for ".concat(lIndex));
    }
  }, {
    key: "optionsTransformer",
    value: function optionsTransformer(options, docxtemplater) {
      verifyApiVersion(docxtemplater, this.requiredAPIVersion);
      this.docxtemplater = docxtemplater;
      var relsFiles = docxtemplater.zip.file(/numbering.xml/).concat(docxtemplater.zip.file(/\[Content_Types\].xml/)).concat(docxtemplater.zip.file(/word\/styles\.xml/)).concat(docxtemplater.zip.file(/\.xml\.rels/)).map(function (file) {
        return file.name;
      });
      options.xmlFileNames = options.xmlFileNames.concat(relsFiles);
      docxtemplater.fileTypeConfig.tagsXmlLexedArray.push("w:bCs", "w:bidi", "w:bookmarkStart", "w:cols", "w:col", "w:ind", "w:jc", "w:pPr", "w:numPr", "w:ilvl", "w:numId", "w:pStyle", "w:smallCaps", "w:pgMar", "w:pgSz", "w:rFonts", "w:rPr", "w:rtl", "w:rStyle", "w:sdtContent", "w:sectPr", "w:spacing", "w:sz", "w:highlight", "w:i", "w:b", "w:color", "w:rStyle", "w:strike", "w:drawing", "mc:AlternateContent", "mc:Choice", "w:vertAlign", "w:u", "w:lang", "w:tabs", "w:tab", "w:szCs");
      if (this.img) {
        return this.img.optionsTransformer(options, docxtemplater);
      }
      return options;
    }
  }, {
    key: "getFileType",
    value: function getFileType(_ref3) {
      var _this = this;
      var doc = _ref3.doc;
      doc.targets.forEach(function (target) {
        var contentType = doc.filesContentTypes[target];
        if (main.indexOf(contentType) !== -1) {
          _this.mainFile = target;
          _this.mainRelsFile = getRelsFilePath(target);
        }
      });
    }
  }, {
    key: "preparse",
    value: function preparse(parsed, options) {
      var _this$W, _options$filePath;
      var relsType = options.relsType;
      if (relsType && relsType !== "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument") {
        return;
      }
      (_this$W = this.W)[_options$filePath = options.filePath] || (_this$W[_options$filePath] = dimensionCollector(this));
      var W = this.W[options.filePath];
      W.collect(parsed, options);
    }
  }, {
    key: "matchers",
    value: function matchers() {
      var _this2 = this;
      var onMatch = function onMatch() {
        if (!_this2.styleManager) {
          _this2.addStyles();
        }
      };
      return [[this.blockPrefix, moduleNameBlock, {
        onMatch: onMatch
      }], [this.prefix, moduleNameInline, {
        onMatch: onMatch
      }]];
    }
  }, {
    key: "postparse",
    value: function postparse(parsed) {
      var _this3 = this;
      parsed.forEach(function (part) {
        if (isStartingTag(part, "w:bookmarkStart")) {
          _this3.minBookmarkId = Math.max(_this3.minBookmarkId, parseInt(getSingleAttribute(part.value, "w:id"), 10));
        }
      });
      parsed = traits.expandToOne(parsed, {
        moduleName: moduleNameBlock,
        getInner: getInner,
        expandTo: "w:p",
        error: {
          message: "HTML tag should be the only text in a paragraph",
          id: "html_tag_w_p_noexpand",
          explanation: function explanation(part) {
            return "The html tag \"".concat(part.value, "\" should not be placed inside a paragraph thas has other content");
          }
        }
      });
      var pp = parsed.postparsed;
      pp.forEach(function (part, i) {
        var nextPart;
        if (part.module !== moduleNameBlock) {
          return;
        }
        for (var j = i + 1, len = pp.length; j < len; j++) {
          if (!pp[j]) {
            return;
          }
          if (pp[j].type !== "content") {
            nextPart = pp[j];
            break;
          }
        }
        if (!nextPart) {
          return;
        }
        if (nextPart.tag === "w:sectPr" || nextPart.tag === "w:p") {
          part.hasBlockAfter = true;
        }
        if (nextPart.tag === "w:tc") {
          part.hasTCAfter = true;
        }
      });
      return parsed;
    }
  }, {
    key: "resolve",
    value: function resolve(part, options) {
      var _this4 = this;
      this.filePath = options.filePath;
      if (part.type !== "placeholder" || [moduleNameBlock, moduleNameInline].indexOf(part.module) === -1) {
        return null;
      }
      var resolvedId = options.resolvedId;
      var dimensions = this.W[options.filePath].getDimensions(part, options);
      copyDimensionsToPart(dimensions, part);
      return options.scopeManager.getValueAsync(part.value, {
        part: part
      }).then(function (htmlData) {
        if (htmlData == null) {
          return options.nullGetter(part, options.scopeManager);
        }
        return htmlData;
      }).then(function (htmlData) {
        _this4.resolved[resolvedId] = {
          tagValue: htmlData
        };
        if (!htmlData) {
          return {
            value: ""
          };
        }
        if (!(htmlData instanceof Array)) {
          htmlData = [htmlData];
        }
        var htmlT = _this4.getTransformer(part, options, htmlData);
        addCustomProperties(htmlT.handler.dom, _this4);
        var imagePromises = [];
        var subindex = 0;
        if (_this4.options.img) {
          tapRecursive(htmlT.handler.dom, function (element) {
            if (element.type === "tag" && element.name === "img") {
              forEachStyleDeclaration(element, htmlT, function () {
                return null;
              });
              var src = element.attribs.src;
              var lIndex = part.lIndex,
                containerWidth = part.containerWidth,
                containerHeight = part.containerHeight,
                pageHeight = part.pageHeight,
                pageWidth = part.pageWidth,
                section = part.section;
              element.lIndex = lIndex + "--" + subindex++;
              var htmlContent = getHtmlContent(element);
              var value = _this4.img.resolve({
                type: "placeholder",
                module: element.centered ? "open-xml-templating/docxtemplater-image-module-centered" : "open-xml-templating/docxtemplater-image-module",
                value: {
                  element: element,
                  src: src,
                  part: part,
                  transformer: htmlT,
                  htmlContent: htmlContent
                },
                lIndex: element.lIndex,
                containerWidth: containerWidth,
                containerHeight: containerHeight,
                pageWidth: pageWidth,
                pageHeight: pageHeight,
                section: section
              }, {
                filePath: options.filePath,
                resolvedId: element.lIndex + options.scopeManager.scopePathItem.join("-"),
                scopeManager: _objectSpread(_objectSpread({}, options.scopeManager), {}, {
                  getValue: function getValue(src) {
                    return src;
                  },
                  getValueAsync: function getValueAsync(src) {
                    return Promise.resolve(src);
                  }
                })
              });
              imagePromises.push(value);
            }
          });
        }
        return Promise.all(imagePromises);
      });
    }
  }, {
    key: "getTransformer",
    value: function getTransformer(part, options, htmlData) {
      if (htmlData instanceof Array) {
        htmlData = htmlData.join("");
      }
      var resolvedId = options.resolvedId;
      if (this.transformers[resolvedId]) {
        return this.transformers[resolvedId];
      }
      var htmlT = new HtmlTransformer(this, part, options);
      this.transformers[resolvedId] = htmlT;
      if (Object.keys(this.transformers).length === 1 && this.styleSheetErrors.length > 0) {
        htmlT.collectErrors(this.styleSheetErrors);
      }
      htmlT.parse(htmlData);
      return this.transformers[resolvedId];
    }
  }, {
    key: "transformHtmlData",
    value: function transformHtmlData(htmlData, part) {
      if (!(htmlData instanceof Array)) {
        htmlData = [htmlData];
      }
      for (var i = 0, len = htmlData.length; i < len; i++) {
        var htmlD = this.convertData(htmlData[i]);
        htmlData[i] = htmlD;
        if (typeof htmlD !== "string") {
          var type = getType(htmlD);
          var err = new Docxtemplater.Errors.RenderingError("HTMLData should be a string (given ".concat(type, ")"));
          err.properties = {
            explanation: "Incorrect data type given to HTML tag",
            id: "html_tag_invalid_type",
            type: type,
            offset: part.offset
          };
          return {
            errors: [err]
          };
        }
      }
      return htmlData;
    }
  }, {
    key: "convertData",
    value: function convertData(htmlData) {
      if (typeof htmlData === "number" || _typeof(htmlData) === "object" && htmlData.substr && htmlData.toString) {
        return htmlData.toString();
      }
      return htmlData;
    }
  }, {
    key: "getHtmlData",
    value: function getHtmlData(part, options) {
      var _options$scopeManager;
      var resolvedId = options.resolvedId;
      if (this.resolved[resolvedId]) {
        return this.resolved[resolvedId].tagValue;
      }
      return (_options$scopeManager = options.scopeManager.getValue(part.value, {
        part: part
      })) !== null && _options$scopeManager !== void 0 ? _options$scopeManager : options.nullGetter(part, options.scopeManager);
    }
  }, {
    key: "render",
    value: function render(part, options) {
      var _this5 = this;
      this.filePath = options.filePath;
      if (part.tag === "w:sectPr") {
        this.columnNum = 0;
      }
      if (hasColumnBreak([part])) {
        this.columnNum++;
      }
      if (part.type !== "placeholder" || [moduleNameBlock, moduleNameInline].indexOf(part.module) === -1) {
        return null;
      }
      if (part.hasColumnBreak) {
        this.columnNum++;
      }
      part.renderColumnBreak = part.hasColumnBreak;
      var W = this.W[options.filePath];
      var dimensions = W.getDimensions(part, options);
      copyDimensionsToPart(dimensions, part);
      var htmlData = this.getHtmlData(part, options);
      function getDrawings(paragraph) {
        var drawingChunks = [];
        var level = 0;
        var chunks = chunkBy(paragraph, function (part) {
          if (part.type === "tag" && part.tag === "w:r") {
            if (part.position === "start") {
              level++;
              if (level === 1) {
                return part.position;
              }
            }
            if (part.position === "end") {
              level--;
              if (level === 0) {
                return part.position;
              }
            }
          }
        });
        chunks.forEach(function (chunk) {
          var hasDrawing = chunk.some(function (part) {
            return part.type === "tag" && part.tag === "mc:AlternateContent";
          });
          if (hasDrawing) {
            pushArray(drawingChunks, chunk);
          }
        });
        return options.joinUncorrupt(drawingChunks.map(function (x) {
          if (x.position === "insidetag") {
            return "";
          }
          return x.value || "";
        }), options).join("").replace(/<w:t xml:space="preserve"><\/w:t>/g, "<w:t/>");
      }
      var fullParagraph = W.getParagraph(part.lIndex).parts;
      var drawingChunks = getDrawings(fullParagraph);
      if (!htmlData) {
        if (drawingChunks) {
          return {
            value: "<w:p>".concat(drawingChunks, "</w:p>")
          };
        }
        return {
          value: ""
        };
      }
      var result = this.transformHtmlData(htmlData, part);
      if (result.errors) {
        return result;
      }
      htmlData = result;
      this.currentPageSize = pick(this.getNextWSect(part.lIndex), ["width", "leftMargin", "rightMargin", "cols"]);
      var isInline = part.module === moduleNameInline;
      var res = this.transformHtmlData(htmlData, part);
      if (res.errors) {
        return res;
      }
      htmlData = res;
      var htmlT = this.getTransformer(part, options, htmlData);
      var tagStyleSheet = null;
      tapRecursive(htmlT.handler.dom, function (el) {
        if (el.type === "style" && el.name === "style") {
          var _result = cssParse(getTextContent(el), _objectSpread(_objectSpread({}, _this5.options), {}, {
            source: "global-style"
          }));
          var styleSheet = _result.parsed;
          if (_result.errors) {
            htmlT.collectErrors(_result.errors);
          }
          if (!tagStyleSheet) {
            tagStyleSheet = styleSheet;
          } else {
            tagStyleSheet.stylesheet.rules = tagStyleSheet.stylesheet.rules.concat(styleSheet.stylesheet.rules);
          }
        }
      });
      htmlT.tagStyleSheet = tagStyleSheet;
      var fullRun = W.getRun(part.lIndex).parts;
      var run = getProperties(fullRun, "w:r", 0);
      var runProperties = getProperties(run, "w:rPr");
      var insideRPR = false;
      var paragraphRunProperties = [];
      var customProperties = getProperties(fullParagraph, "w:pPr", 1).filter(function (p) {
        if (p.tag === "w:rPr" && p.position === "end") {
          insideRPR = false;
          return false;
        }
        if (insideRPR) {
          if (p.type !== "content") {
            p.insideRPR = true;
            paragraphRunProperties.push(p);
          }
        }
        if (p.tag === "w:rPr" && p.position === "start") {
          insideRPR = true;
        }
        return p.type !== "content" && !insideRPR;
      });
      var inTag = false;
      var tag = null;
      var otherProperties = [];
      var otherRunProperties = [];
      customProperties.forEach(function (prop) {
        if (prop.tag === "w:pStyle") {
          var pStyle = getSingleAttribute(prop.value, "w:val");
          htmlT.pStyle = pStyle;
          var xml = xmlparse(xml2str(_this5.styleManager.getStyle({
            id: pStyle
          })), {
            text: [],
            other: _this5.docxtemplater.fileTypeConfig.tagsXmlLexedArray
          });
          otherProperties = otherProperties.concat(getProperties(xml, "w:pPr", 0).filter(function (p) {
            if (p.tag === "w:rPr" && p.position === "end") {
              insideRPR = false;
              return false;
            }
            if (insideRPR) {
              if (p.type !== "content") {
                paragraphRunProperties.push(p);
              }
            }
            if (p.tag === "w:rPr" && p.position === "start") {
              insideRPR = true;
            }
            return p.type !== "content" && !insideRPR;
          }).map(function (prop) {
            prop.fromPStyle = true;
            return prop;
          }));
          otherRunProperties = otherRunProperties.concat(getProperties(xml, "w:rPr", 0));
        }
      });
      htmlT.pStyleProps = otherProperties.filter(function (x) {
        if (tag && ["w:tabs", "w:numPr"].indexOf(x.tag) !== -1 && x.position === "end") {
          inTag = false;
          tag.fullValue.push(x);
          return false;
        }
        if (inTag) {
          tag.fullValue.push(x);
          return false;
        }
        if (["w:tabs", "w:numPr"].indexOf(x.tag) !== -1 && x.position === "start") {
          inTag = true;
          tag = x;
          tag.fullValue = [_objectSpread({}, x)];
        }
        return true;
      });
      htmlT.otherRunProperties = otherRunProperties;
      customProperties = customProperties.filter(function (x) {
        if (tag && ["w:tabs", "w:numPr"].indexOf(x.tag) !== -1 && x.position === "end") {
          inTag = false;
          tag.fullValue.push(x);
          return false;
        }
        if (inTag) {
          tag.fullValue.push(x);
          return false;
        }
        if (["w:tabs", "w:numPr"].indexOf(x.tag) !== -1 && x.position === "start") {
          inTag = true;
          tag = x;
          tag.fullValue = [_objectSpread({}, x)];
        }
        return true;
      });
      var transformer = isInline ? htmlT.transformInline.bind(htmlT) : htmlT.transformBlock.bind(htmlT);
      var value = transformer(runProperties, customProperties, paragraphRunProperties, part, drawingChunks, otherRunProperties);
      if (isInline) {
        var runProps = "";
        if (runProperties.length > 0) {
          runProps = "<w:rPr>";
          runProps += runProperties.map(function (_ref4) {
            var value = _ref4.value;
            return value;
          }).join("");
          runProps += "</w:rPr>";
        } else {
          runProps = "<w:rPr/>";
        }
        return {
          value: "</w:t></w:r>".concat(value, "<w:r>").concat(runProps, "<w:t xml:space=\"preserve\">")
        };
      }
      return {
        value: value
      };
    }
  }]);
  return HtmlModule;
}();
module.exports = HtmlModule;
module.exports["default"] = HtmlModule;